module.exports = __webpack_public_path__ + "static/img/logo1.0bcdfe29.png";